<template>
  <div class="toolsPanelList">
    <div class="toolsPanelList__title">
      <span>Computed Properties:</span>
    </div>
    <ul v-for="(prop, key) in widgetsComputed" :key="key" class="toolsPanelList__list">
      <li class="toolsPanelList__listItem">
        <a href="#" @click.prevent="edit(key)">{{ key }}</a>
        <a href="#" class="toolsPanelList__removeListItem" @click.prevent="remove(key)">
          <icon name="remove" />
        </a>
      </li>
    </ul>
    <b-button class="toolsPanelList__addBtn" variant="primary" size="sm" @click="create">
      <icon name="plus" />
      <span>Create</span>
    </b-button>
    <ComputedPropModal :prop="curProp" :props="widgetsComputed" />
  </div>
</template>

<script>
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'
// components
import ComputedPropModal from '@/components/Modals/ComputedProp'

export default {
  components: {
    ComputedPropModal,
  },
  data() {
    return {
      widgetsComputed: {},
      curProp: null,
    }
  },
  methods: {
    create() {
      this.curProp = null
      eventBus.$emit('showComputedPropModal')
    },
    edit(key) {
      this.$store.commit('editComputed', {
        key: key,
        insert: true,
      })
    },
    remove(key) {
      let doRemove = confirm('Are you sure?')
      if (!doRemove) return

      this.$store.commit('addProcess', {
        process: 'removeComputed',
        message: 'Removing',
      })

      db.computed.delete(key, err => {
        this.$store.commit('deleteProcess', 'removeComputed')
        if (err) {
          this.$store.commit('addError', err.message)
        }
      })
    },
  },
  created() {
    db.computed.read(computed => {
      this.widgetsComputed = computed
    })
  },
}
</script>
